import { useMemo } from "react";
import {
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableHeader,
  TableCellLink,
  StyledEditIcon,
} from "./ObjectTable.styles";
import type { Dealer } from "./DealersPage";

interface ObjectTableProps {
  data: Dealer[];
  filters: { field: string; value: string }[];
  objectKeys: string[];
  editButtonHandler: (dealer: Dealer) => void;
}

export default ({
  data,
  filters,
  objectKeys,
  editButtonHandler,
}: ObjectTableProps) => {
  if (!data || data.length === 0) {
    return <p>No data to display.</p>;
  }

  const isSelected = (key: string) =>
    filters && filters.some((filter) => filter.field === key);

  const tableRows = useMemo(() => {
    return data.map((item, index) => (
      <TableRow key={index}>
        <TableCell>
          <StyledEditIcon onClick={() => editButtonHandler(item)} />
        </TableCell>
        {objectKeys.map((key) => {
          if (key === "id") {
            return (
              <TableCell key={key}>
                <TableCellLink href={`/${item[key]}/dashboard`}>
                  {item[key]}
                </TableCellLink>
              </TableCell>
            );
          } else {
            return <TableCell key={key}>{item[key]}</TableCell>;
          }
        })}
      </TableRow>
    ));
  }, [data, objectKeys]);

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeader>Edit</TableHeader>
          {objectKeys.map((key) => (
            <TableHeader key={key} isSelected={isSelected(key)}>
              {key}
              {key === "id" && " (click to navigate)"}
            </TableHeader>
          ))}
        </TableRow>
      </TableHead>
      <tbody>{tableRows}</tbody>
    </Table>
  );
};
